// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* NavigationMenu.css */

.navigation-menu {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  padding: 0;
  box-shadow: none;
}
.navigation-menu-list{
  display: flex;
  max-width: max-content;
  margin: 0 auto;
}
.menu-item {
  position: relative;
  display: flex;
  align-items: center;
  padding: 0;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  list-style: none;
}

.menu-label {
  background: transparent;
  border: none;
  padding: 8px 10px;
  margin: 0;
  color: #111 !important;
  font-weight: 600;
  font-size: 12px;
  line-height: 1.2;
  text-transform: uppercase;
  cursor: pointer;
}

.submenu-label {
  background: transparent;
  border: none;
  padding: 0;
  margin: 0;
  font: inherit;
  color: inherit;
  cursor: pointer;
}

.menu-item > a{
  display: block;
    position: relative;
    padding: 0 16px;
    font-size: 12px;
    line-height: 45px;
    font-weight: 600;
    color: #111 !important;
    text-transform: uppercase;
    cursor: pointer;
    text-decoration: none;
}
.menu-item:hover .arrow {
  transform: rotate(180deg);
}

.menu-item.submenu-open .arrow {
  transform: rotate(180deg);
}

.arrow {
  content: '▼';
  display: inline-block;
  margin-left: 5px;
  color: #999;
  transition: transform 0.3s ease;
}

/* Header desktop nav: hide dropdown arrows as requested */
@media (min-width: 768px) {
  .navigation-menu .arrow {
    display: none;
  }
}

.submenu {
  position: absolute;
  width: 220px;
  top: 100%;
  left: 0;
  right: auto;
  list-style: none;
  padding: 0;
  margin: 0;
  background-color: #fff;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  z-index: 20;
  display: none;
  border-radius: 0 0 5px 5px;
  /* Deliberately NOT overflow:hidden/auto here: .inner-submenu's flyout is
     an absolutely-positioned descendant of this element, so clipping here
     would clip the flyout too (it's not scoped to .submenu's own box). */
}

.menu-item:hover .submenu {
  display: block;
}

.menu-item.submenu-open .submenu {
  display: block;
}

.submenu-item {
  padding: 12px 20px;
  cursor: pointer;
  border-bottom: 1px solid #ddd;
  -webkit-user-select: none;
          user-select: none;
  font-size: 14px;
  color: #333;
  width: 100%;
  max-width: 100%;
}

.submenu-item:last-child {
  border-bottom: none;
}

.inner-submenu {
  position: absolute;
  top: 0;
  /* Clamp so the flyout can never push past the right edge of the viewport
     (fixed 500px was overflowing off-screen on common 1280–1366px laptop
     widths, since it flies out from wherever the hovered item happens to sit). */
  width: min(460px, calc(100vw - 320px));
  min-width: 320px;
  max-height: 70vh;
  left: 100%;
  list-style: none;
  padding: 10px 0;
  margin: 0;
  background-color: #fff;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  z-index: 21;
  display: none;
  border-radius: 0 5px 5px 5px;
  overflow-y: auto;
}

/* Below ~1280px there isn't reliably enough room for a 320px+ flyout next to
   a 220px submenu, so drop the fly-out entirely and expand it inline instead. */
@media (max-width: 1279px) {
  .inner-submenu {
    position: static;
    width: 100%;
    min-width: 0;
    max-height: none;
    overflow: visible;
    box-shadow: none;
    border-radius: 0;
    border-top: 1px solid #eee;
    margin-top: 4px;
    padding: 8px 12px;
  }

  .inner-submenu table,
  .inner-submenu tbody,
  .inner-submenu tr {
    display: block;
    width: 100%;
  }

  .inner-submenu td.column {
    display: block;
    width: 100%;
    padding: 0;
  }
}

.inner-submenu-list{
  list-style: none;
  padding-left: 14px;
}
.submenu-item:hover .inner-submenu {
  display: block;
}

.submenu-item.inner-open .inner-submenu {
  display: block;
}

.inner-menu-item {
  text-align: left;
  padding: 4px 8px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  font-size: 13px;
  color: #333;
}

.inner-menu-item:last-child {
  border-bottom: none;
} 
.column {
  vertical-align: top;
}

.inner-menu-item a{
  text-decoration: none;
  color: black;
}

.inner-menu-item a:hover{
  text-decoration: underline;
  color: #0d6efd;;
}`, "",{"version":3,"sources":["webpack://./src/css/MenuItem.css"],"names":[],"mappings":"AAAA,uBAAuB;;AAEvB;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,SAAS;EACT,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,UAAU;EACV,SAAS;EACT,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAEhB,sBAAsB;IACtB,yBAAyB;IACzB,eAAe;IACf,qBAAqB;AACzB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;EACX,+BAA+B;AACjC;;AAEA,0DAA0D;AAC1D;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,OAAO;EACP,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,sBAAsB;EACtB,wCAAwC;EACxC,WAAW;EACX,aAAa;EACb,0BAA0B;EAC1B;;yEAEuE;AACzE;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,yBAAiB;UAAjB,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN;;iFAE+E;EAC/E,sCAAsC;EACtC,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,sBAAsB;EACtB,wCAAwC;EACxC,WAAW;EACX,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;gFACgF;AAChF;EACE;IACE,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,0BAA0B;IAC1B,eAAe;IACf,iBAAiB;EACnB;;EAEA;;;IAGE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,cAAc;IACd,WAAW;IACX,UAAU;EACZ;AACF;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB","sourcesContent":["/* NavigationMenu.css */\n\n.navigation-menu {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 10px;\n  padding: 0;\n  box-shadow: none;\n}\n.navigation-menu-list{\n  display: flex;\n  max-width: max-content;\n  margin: 0 auto;\n}\n.menu-item {\n  position: relative;\n  display: flex;\n  align-items: center;\n  padding: 0;\n  cursor: pointer;\n  user-select: none;\n  list-style: none;\n}\n\n.menu-label {\n  background: transparent;\n  border: none;\n  padding: 8px 10px;\n  margin: 0;\n  color: #111 !important;\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 1.2;\n  text-transform: uppercase;\n  cursor: pointer;\n}\n\n.submenu-label {\n  background: transparent;\n  border: none;\n  padding: 0;\n  margin: 0;\n  font: inherit;\n  color: inherit;\n  cursor: pointer;\n}\n\n.menu-item > a{\n  display: block;\n    position: relative;\n    padding: 0 16px;\n    font-size: 12px;\n    line-height: 45px;\n    font-weight: 600;\n    text-decoration: none;\n    color: #111 !important;\n    text-transform: uppercase;\n    cursor: pointer;\n    text-decoration: none;\n}\n.menu-item:hover .arrow {\n  transform: rotate(180deg);\n}\n\n.menu-item.submenu-open .arrow {\n  transform: rotate(180deg);\n}\n\n.arrow {\n  content: '▼';\n  display: inline-block;\n  margin-left: 5px;\n  color: #999;\n  transition: transform 0.3s ease;\n}\n\n/* Header desktop nav: hide dropdown arrows as requested */\n@media (min-width: 768px) {\n  .navigation-menu .arrow {\n    display: none;\n  }\n}\n\n.submenu {\n  position: absolute;\n  width: 220px;\n  top: 100%;\n  left: 0;\n  right: auto;\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  background-color: #fff;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n  z-index: 20;\n  display: none;\n  border-radius: 0 0 5px 5px;\n  /* Deliberately NOT overflow:hidden/auto here: .inner-submenu's flyout is\n     an absolutely-positioned descendant of this element, so clipping here\n     would clip the flyout too (it's not scoped to .submenu's own box). */\n}\n\n.menu-item:hover .submenu {\n  display: block;\n}\n\n.menu-item.submenu-open .submenu {\n  display: block;\n}\n\n.submenu-item {\n  padding: 12px 20px;\n  cursor: pointer;\n  border-bottom: 1px solid #ddd;\n  user-select: none;\n  font-size: 14px;\n  color: #333;\n  width: 100%;\n  max-width: 100%;\n}\n\n.submenu-item:last-child {\n  border-bottom: none;\n}\n\n.inner-submenu {\n  position: absolute;\n  top: 0;\n  /* Clamp so the flyout can never push past the right edge of the viewport\n     (fixed 500px was overflowing off-screen on common 1280–1366px laptop\n     widths, since it flies out from wherever the hovered item happens to sit). */\n  width: min(460px, calc(100vw - 320px));\n  min-width: 320px;\n  max-height: 70vh;\n  left: 100%;\n  list-style: none;\n  padding: 10px 0;\n  margin: 0;\n  background-color: #fff;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n  z-index: 21;\n  display: none;\n  border-radius: 0 5px 5px 5px;\n  overflow-y: auto;\n}\n\n/* Below ~1280px there isn't reliably enough room for a 320px+ flyout next to\n   a 220px submenu, so drop the fly-out entirely and expand it inline instead. */\n@media (max-width: 1279px) {\n  .inner-submenu {\n    position: static;\n    width: 100%;\n    min-width: 0;\n    max-height: none;\n    overflow: visible;\n    box-shadow: none;\n    border-radius: 0;\n    border-top: 1px solid #eee;\n    margin-top: 4px;\n    padding: 8px 12px;\n  }\n\n  .inner-submenu table,\n  .inner-submenu tbody,\n  .inner-submenu tr {\n    display: block;\n    width: 100%;\n  }\n\n  .inner-submenu td.column {\n    display: block;\n    width: 100%;\n    padding: 0;\n  }\n}\n\n.inner-submenu-list{\n  list-style: none;\n  padding-left: 14px;\n}\n.submenu-item:hover .inner-submenu {\n  display: block;\n}\n\n.submenu-item.inner-open .inner-submenu {\n  display: block;\n}\n\n.inner-menu-item {\n  text-align: left;\n  padding: 4px 8px;\n  cursor: pointer;\n  user-select: none;\n  font-size: 13px;\n  color: #333;\n}\n\n.inner-menu-item:last-child {\n  border-bottom: none;\n} \n.column {\n  vertical-align: top;\n}\n\n.inner-menu-item a{\n  text-decoration: none;\n  color: black;\n}\n\n.inner-menu-item a:hover{\n  text-decoration: underline;\n  color: #0d6efd;;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
